import React from "react";

export function Logo({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 110" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="SoverenX">
      <path
        d="M50 4 L92 20 V54 C92 82 72 100 50 106 C28 100 8 82 8 54 V20 Z"
        fill="#0f172a"
        stroke="#3b82f6"
        strokeWidth="3"
      />
      <path
        d="M50 12 L84 25 V54 C84 77 68 92 50 98 C32 92 16 77 16 54 V25 Z"
        fill="none"
        stroke="#1e40af"
        strokeWidth="1.5"
        opacity="0.6"
      />
      <text x="50" y="66" textAnchor="middle" fontFamily="Outfit, sans-serif" fontWeight="800" fontSize="42" fill="#3b82f6">
        SX
      </text>
    </svg>
  );
}

export function LogoWord({ size = 32 }) {
  return (
    <div className="flex items-center gap-2.5">
      <Logo size={size} />
      <div className="leading-none">
        <div className="font-head font-extrabold tracking-tight text-white text-lg">SoverenX</div>
        <div className="overline text-slate-500">Systems</div>
      </div>
    </div>
  );
}
